/* eslint no-console: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'

import { useMe } from '../../../../../presentation/contexts/me'
import { usePage } from '../../../../../presentation/contexts/page'
import { useSnackbar } from '../../../../../presentation/contexts/snackbar'
import { AssessmentsKind } from '../../../../../presentation/enums/assessments.enum'
import { makeAssessment } from '../../../../usecases/assessments/load-assessment-factory'
import AssessmentEditor from '../../../../../presentation/pages/dashboard/configurations/assessments/editor'
import { makeStablishments } from '../../../../usecases/stablishments/load-stablishments'
import { useLoading } from '../../../../../presentation/contexts/loading'

const MakeAssessmentEditor = () => {
  const { setHeader } = usePage()
  const { onSetLoading } = useLoading()
  const { me } = useMe()
  const { setIsShowing, setText, setType } = useSnackbar()
  const [assessmentIsActive, setAssessmentIsActive] = useState()
  const [initialFormData, setInitialFormData] = useState<any>(null)
  const [initialAssessmentsData, setInitialAssessmentsData] = useState<any>(null)

  const loadAssessment = async () => {
    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      const response = await makeAssessment(stablishmentId).load()
      const formattedData = response.assessments.map((assessment: any) => ({
        ...assessment,
        kind: String(assessment.kind),
      }))
      setInitialFormData({ assessments: formattedData })
      setInitialAssessmentsData({ isActive: me.stablishments[0].assessmentsIsActive })
    } catch (error) {
      console.log(error)
    }
  }

  const dataForm = [
    {
      items: [
        {
          name: 'isActive',
          component: 'InputSwitch',
          value: '',
          title: 'Deseja ativar esta opção',
          label: 'Deseja ativar esta opção',
          styleContainer: { margin: '20px 0px 35px' },
        },
      ],
    },
  ]

  const assessmentDataForm = [
    {
      items: [
        {
          name: 'title',
          component: 'Input',
          value: '',
          placeholder: 'Ex: A comida estava boa?',
          title: 'Pergunta',
          label: 'Pergunta',
          required: true,
          validations: 'inputRequired',
        },
        {
          name: 'kind',
          component: 'InputRadio',
          required: true,
          value: '',
          title: 'Tipo de resposta',
          label: 'Tipo de resposta',
          options: [
            { label: 'Sim/Não', value: AssessmentsKind.YES_NO },
            { label: 'Campo de texto', value: AssessmentsKind.TEXT_FIELD },
            { label: 'Avaliação com 5 estrelas', value: AssessmentsKind.STAR_RATING },
          ],
        },
      ],
    },
  ]

  const formatAssessmentToSubmit = (assessments: any) => (
    assessments.map((assessment: any) => ({
      ...assessment,
      title: assessment.title.trim(),
      kind: Number(assessment.kind),
    }))
  )

  const onSubmit = async (values:any): Promise<void> => {
    const itemToSubmit = formatAssessmentToSubmit(values.assessments)
    const { isActive } = assessmentIsActive as any

    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id

      if (me.stablishments[0].assessmentsIsActive !== isActive) {
        const formData = new FormData()
        formData.append('assessmentsIsActive', isActive)
        await makeStablishments().patch(stablishmentId, formData)
      }

      await makeAssessment(stablishmentId).patch(itemToSubmit)
      await loadAssessment()
      setType('success')
      setText('Salvo com sucesso!')
      setIsShowing(true)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    (async () => {
      setHeader({
        title: 'Avaliações dos pedidos',
        goTo: null,
      })
      onSetLoading(true)
      try {
        await loadAssessment()
      } catch (error) {
        console.log(error)
      } finally {
        onSetLoading(false)
      }
    })()
  }, [me, setHeader])

  return (
    <AssessmentEditor
      initialData={initialFormData}
      initialAssessmentsData={initialAssessmentsData}
      dataForm={dataForm}
      setData={setAssessmentIsActive}
      assessmentDataForm={assessmentDataForm}
      onSubmit={onSubmit}
    />
  )
}

export default MakeAssessmentEditor
